import Container from 'semantic-ui-react/dist/commonjs/elements/Container'
export default Container
